import React from 'react';
import { Link } from 'react-router-dom';

const quickActions = [
  {
    name: 'Create Invoice',
    description: 'Send an invoice to your customer',
    href: '/invoices',
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    name: 'Add Customer',
    description: 'Add a new customer to your records',
    href: '/customers',
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
      </svg>
    ),
  },
  {
    name: 'Record Expense',
    description: 'Record a new business expense',
    href: '/bills',
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v2a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    name: 'Add Item',
    description: 'Add a product or service',
    href: '/items',
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
  },
  {
    name: 'View Reports',
    description: 'Generate financial reports',
    href: '/reports',
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
  },
  {
    name: 'Bank Accounts',
    description: 'Reconcile your bank accounts',
    href: '/bank-accounts',
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
    ),
  },
];

export const QuickActions: React.FC = () => {
  return (
    <div style={{ background: '#ffffff', border: '1px solid #e3dcc4', borderRadius: 12, padding: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
      {/* Header */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, fontWeight: 700, color: '#1c2033', marginBottom: 8 }}>
          Quick Actions
        </div>
        <div style={{ height: 1, background: '#f4efe2' }} />
      </div>

      {/* Action grid */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {quickActions.map(action => (
          <Link
            key={action.name}
            to={action.href}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center',
              textAlign: 'center', gap: 8, padding: '16px 12px',
              background: '#faf7ee',
              border: '1px solid #e3dcc4',
              borderRadius: 10, textDecoration: 'none',
              transition: 'all 0.18s',
              color: '#6b6a5c',
            }}
            onMouseEnter={e => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.background = 'rgba(217,119,6,0.06)';
              el.style.borderColor = 'rgba(217,119,6,0.25)';
              el.style.color = '#d97706';
              el.style.transform = 'translateY(-2px)';
              el.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)';
            }}
            onMouseLeave={e => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.background = '#faf7ee';
              el.style.borderColor = '#e3dcc4';
              el.style.color = '#6b6a5c';
              el.style.transform = 'translateY(0)';
              el.style.boxShadow = 'none';
            }}
          >
            <div style={{ color: 'inherit', transition: 'color 0.18s' }}>
              {action.icon}
            </div>
            <div style={{
              fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 700,
              color: 'inherit', lineHeight: 1.3,
            }}>
              {action.name}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
